import { PersonalisedMannequinResponse } from '@reactivereality/pictofit-web-sdk';
import { RRSpinnerModel } from '../../spinner/models/spinner.model';
import { RRAvatarGeneratorFieldsModel } from './avatar-generator-fields.model';

export interface RRViewerBaseSettings {
  computeServerUrl: string;
  computeServerAuthToken?: string;
  viewerEnvironmentConfigJsonUrl?: string;
  viewerCamaraConfigJsonUrl?: string;
  viewerMaterialJsonUrl?: string | string[];
  mannequinSettings?: RRAvatarGeneratorFieldsModel;
  customMannequin?: PersonalisedMannequinResponse;
  canvasId?: string;
  loadingSpinner?: RRSpinnerModel;
  useStylizedMannequin?: boolean;
}
